import React from 'react'
import {ErrorBoundary, EventInteractive} from '@therms/react-modules'
import {ContainerDimensionsContextProvider, Modal} from '@therms/atalaya'

interface EventModalProps {
  closeHandler: () => void
  eventId: string
}

function EventInteractiveModal({closeHandler, eventId}: EventModalProps) {
  return (
    <Modal closeHandler={closeHandler} escPressClose header="Event" width="lg">
      <ContainerDimensionsContextProvider>
        <ErrorBoundary>
          <EventInteractive eventId={eventId} />
        </ErrorBoundary>
      </ContainerDimensionsContextProvider>
    </Modal>
  )
}

export {EventInteractiveModal}
